enum EContactUs {
  uploadContact = 'contactUs/contact',
  uploadLicensing = 'contactUs/licensing',
}

export default EContactUs;
